module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jlmhx"))).then(() => parcelRequire('1iHdE'));